var _defs, _g, _line, _text, _line2, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoondreamPromptTemplate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 720 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "moondream-arrow",
    viewBox: "0 0 10 10",
    refX: 9,
    refY: 5,
    markerWidth: 6,
    markerHeight: 6,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L10,5 L0,10 z",
    fill: "#6b7280"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontFamily: "ui-monospace, SFMono-Regular, Menlo, Monaco, monospace",
    fontSize: 13,
    fill: "#1f2937"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 30,
    width: 210,
    height: 40,
    rx: 4,
    fill: "#ffffff",
    stroke: "#9ca3af"
  }), /*#__PURE__*/React.createElement("text", {
    x: 115,
    y: 55,
    textAnchor: "middle"
  }, "BOS, target image patches"), /*#__PURE__*/React.createElement("rect", {
    x: 230,
    y: 30,
    width: 110,
    height: 40,
    rx: 4,
    fill: "#ffffff",
    stroke: "#9ca3af"
  }), /*#__PURE__*/React.createElement("text", {
    x: 285,
    y: 55,
    textAnchor: "middle"
  }, "detect prefix"), /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 30,
    width: 60,
    height: 40,
    rx: 4,
    fill: "#fef3c7",
    stroke: "#d97706",
    strokeDasharray: "5 3",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 380,
    y: 56,
    textAnchor: "middle",
    fontWeight: 700
  }, "???"), /*#__PURE__*/React.createElement("rect", {
    x: 420,
    y: 30,
    width: 110,
    height: 40,
    rx: 4,
    fill: "#ffffff",
    stroke: "#9ca3af"
  }), /*#__PURE__*/React.createElement("text", {
    x: 475,
    y: 55,
    textAnchor: "middle"
  }, "detect suffix"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 540,
    y1: 50,
    x2: 600,
    y2: 50,
    stroke: "#6b7280",
    strokeWidth: 1.5,
    fill: "none",
    markerEnd: "url(#moondream-arrow)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 610,
    y: 55,
    fontFamily: "ui-sans-serif, system-ui, sans-serif",
    fontSize: 14,
    fill: "#1f2937"
  }, "boxes")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 380,
    y1: 110,
    x2: 380,
    y2: 78,
    stroke: "#d97706",
    strokeWidth: 2,
    fill: "none",
    markerEnd: "url(#moondream-arrow)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontFamily: "ui-sans-serif, system-ui, sans-serif",
    fontSize: 14,
    fill: "#374151"
  }, /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 140
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 600,
    fill: "#1f2937"
  }, "text path:"), /*#__PURE__*/React.createElement("tspan", {
    dx: 8
  }, "tokens for \u27E8something\u27E9 (text prompt)")), /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 170
  }, /*#__PURE__*/React.createElement("tspan", {
    fontWeight: 600,
    fill: "#1f2937"
  }, "image path:"), /*#__PURE__*/React.createElement("tspan", {
    dx: 6
  }, "embedding(s) from a query image")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoondreamPromptTemplate);
export default __webpack_public_path__ + "static/media/moondream-prompt-template.2a43138fa1f68c689276d7a106a7cdfe.svg";
export { ForwardRef as ReactComponent };